import { Injectable } from '@angular/core';
// import { JwtHelperService, } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class AuthService {
  constructor(private cookieService: CookieService) {}
  public isCompanyAuthenticated(): boolean {
    // let jwtHelper = new JwtHelperService();
    const companyAuth = this.cookieService.get('companyAuth');
    return companyAuth ? true : false;
  }
  public isStaffAuthenticated(): boolean {
    // let jwtHelper = new JwtHelperService();
    const staffAuth = this.cookieService.get('staffAuth');

    return staffAuth ? true : false;
    // return !jwtHelper.isTokenExpired(staffToken);
  }
}